import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { AuthService } from '@et/auth';

@Component({
  selector: 'e-vault-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavbarComponent {
  private authService = inject(AuthService);

  date = new Date();

  /**
   * Log out the user.
   * @returns None
   * @memberof NavbarComponent
   */
  logout(): void {
    this.authService.logout();
  }
}
